<template>
  <div class="row">
    <div class="col-xl-12 col-xs-12 vcenter" >
        <div class="form-middle-lookup">
            <div class="title-form">
                <img src="@/assets/confirm-email-icon.svg" class="ico" width="120"/>
                <div> {{user_data.email}} </div>
                <h2>Please confirm your email first</h2>
                <span class="bigger" v-if="text === 'sent'"> Go to your inbox to confirm your email to continue to Orbitly. </span>
                <div>
                  <button class="btn btn-small m-t-20 bold" @click="sendEmail" v-if="text !== 'sent'"> {{text}}</button>
                </div>
            </div>
        </div>
    </div>
  </div>
</template>

<script>

import { mapMutations } from 'vuex'

export default {
  name: 'email',
  mounted () {
    this.messageStorage.destroyAll()
    if (this.user_data.email_verified) {
      this.$router.push({ name: 'upload_leads' })
    }
  },
  data () {
    return {
      text: 'Re-send email',
      messageStorage: this.flash()
    }
  },
  methods: {

    ...mapMutations([
      'user/setAuthUser'
    ]),

    sendEmail () {
      this.text = 'wait...'
      this.messageStorage.destroyAll()
      this.messageStorage.flash('Go to your inbox to confirm your email', 'success')
      this.$http.get('/api/user/resend_email').then((res) => {
        this.text = 'sent'
        if (res.data.email_verified) {
          this['user/setAuthUser'](res.data)
          this.$router.push({ name: 'upload_leads' })
        } else {
          this.messageStorage.flash('Go to your inbox to confirm your email', 'success')
        }
      }).catch((err) => {
        this.messageStorage.flash(err.data.error, 'error')
      })
    }
  },
  computed: {
    authenticated: function () {
      return this.$store.state.user.authenticated
    },
    user_data: function () {
      return this.$store.state.user.data
    }
  }
}
</script>
